import React from 'react'

import magiclyImg from './images/magicly.png'
import aibooksImg from './images/aibooks.png'
import logoImg from './images/logo.png'
import azureImg from './images/azure.svg'
import amazonImg from './images/amazon.svg'
import nvidiaImg from './images/nvidia.svg'
import ecocityImg from './images/ecocity.png'
import darkrainImg from './images/darkrain.png'
import penthouseImg from './images/penthouse.png'
import sokbImg from './images/sokb.png'
import musicImg from './images/music.png'
import severoImg from './images/severo.png'
import microsoftImg from './images/microsoft.svg'

import c from './DevelopmentPage.module.scss'

function DevelopmentPage() {
  return (
    <div className={c.container}>

      {/* HEADER */}
      <header className={c.header}>
        <div className={c.logo}>
          <img src={logoImg} alt="" /> Retomagic
        </div>
        <nav className={c.nav}>
          <a href="#projects">Проекты</a>
          <a href="#services">Услуги</a>
          <a href="#process">Процесс</a>
          <a href="#contact">Контакты</a>
        </nav>
      </header>

      {/* HERO */}
      <section className={c.hero}>
        <div className={c.heroGlow} />
        <img src={logoImg} className={c.heroImage} alt="" />

        <div className={c.heroContent}>
          <h1>AI-разработка и цифровые продукты</h1>
          <p>
            Retomagic — технологическая студия полного цикла.
            Мы создаём и внедряем AI-решения, веб- и мобильные продукты
            для бизнеса, стартапов и цифровых сервисов.
          </p>

          <div className={c.heroActions}>
            <div>
              <a href="#contact" className={c.primaryBtn}>
                Разобрать задачу с инженером
              </a>
            </div>

            <span className={c.ctaNote}>
              Ответим в течение 24 часов · Без обязательств
            </span>
          </div>

          <div className={c.heroStats}>
            <div>
              <b>10+</b>
              <span>запущенных продуктов</span>
            </div>
            <div>
              <b>5+ лет</b>
              <span>опыта разработки</span>
            </div>
            <div>
              <b>AI · Web · Mobile</b>
              <span>ключевая экспертиза</span>
            </div>
          </div>
        </div>
      </section>

      <div className={c.sectionDivider} />

      {/* PARTNERS */}
      <section className={c.partners}>
        <img src={microsoftImg} alt="Microsoft" />
        <img src={amazonImg} alt="Amazon" />
        <img src={azureImg} alt="Azure" />
        <img src={nvidiaImg} alt="NVIDIA" />
      </section>

      <div className={c.sectionDivider} />

      {/* PROJECTS */}
      <section id="projects" className={c.projects}>
        <h2>Наши продукты</h2>
        <p className={c.sectionDesc}>
          Мы разрабатываем не прототипы, а полноценные продукты,
          готовые к масштабированию и реальному использованию.
        </p>

        <div className={c.projectGrid}>
          <div className={c.projectCard}>
            <div>
              <span className={c.projectTag}>AI · Mobile · Product</span>
              <h3>Magicly</h3>
              <p>
                Платформа AI-арта и улучшения изображений.
                Генерация, редактирование и визуальный контент
                для пользователей и креаторов.
              </p>
              <a href="/">Перейти к проекту →</a>
            </div>
            <img src={magiclyImg} alt="Magicly" />
          </div>

          <div className={c.projectCard}>
            <div>
              <span className={c.projectTag}>AI · Speech · SaaS</span>
              <h3>AI Books</h3>
              <p>
                Платформа синтеза речи для озвучивания книг,
                статей и образовательных материалов
                с использованием нейросетей.
              </p>
              <a href="/">Перейти к проекту →</a>
            </div>
            <img src={aibooksImg} alt="AI Books" />
          </div>

          <div className={c.projectCard}>
            <div>
              <span className={c.projectTag}>AI · Music · Platform</span>
              <h3>Music Bomb</h3>
              <p>
                AI-платформа для генерации и продакшна музыки: создавайте треки, редактируйте партии и миксуйте в пару кликов.
              </p>
              <a href="/">Перейти к проекту →</a>
            </div>
            <img src={musicImg} alt="Music Bomb" />
          </div>

          <div className={c.projectCard}>
            <div>
              <span className={c.projectTag}>Web · Travel · Community</span>
              <h3>Северо-кавказский горный клуб</h3>
              <p>
                Платформа для активного отдыха и здоровья: маршруты, туры, мероприятия и подбор путешествий «под себя».
              </p>
              <a href="/">Перейти к проекту →</a>
            </div>
            <img src={severoImg} alt="Северо-кавказский горный клуб" />
          </div>


          <div className={c.projectCard}>
            <div>
              <span className={c.projectTag}>Web · E-commerce · Brand</span>
              <h3>Darkrain</h3>
              <p>
                Ювелирный бренд из серебра: минимализм, чистая эстетика и коллекции вне сезонных трендов.
              </p>
              <a href="/">Перейти к проекту →</a>
            </div>
            <img src={darkrainImg} alt="Darkrain" />
          </div>


          <div className={c.projectCard}>
            <div>
              <span className={c.projectTag}>Web · Real Estate · Investment</span>
              <h3>Penthouse.ae</h3>
              <p>
                Премиальная платформа для инвестиций в элитную недвижимость Дубая при поддержке Metropolitan Group.
              </p>
              <a href="/">Перейти к проекту →</a>
            </div>
            <img src={penthouseImg} alt="Penthouse.ae" />
          </div>


          <div className={c.projectCard}>
            <div>
              <span className={c.projectTag}>Web · Construction · Company</span>
              <h3>Eco City</h3>
              <p>
                Проектирование и строительство современных домов из СИП-панелей для постоянного и сезонного проживания.
              </p>
              <a href="/">Перейти к проекту →</a>
            </div>
            <img src={ecocityImg} alt="Eco City" />
          </div>

          <div className={c.projectCard}>
            <div>
              <span className={c.projectTag}>Web · Healthcare · Government</span>
              <h3>СОКПБ</h3>
              <p>
                Официальный сайт и цифровые сервисы областной психиатрической больницы: информация, подразделения, контакты и обращения.
              </p>
              <a href="/">Перейти к проекту →</a>
            </div>
            <img src={sokbImg} alt="СОКПБ" />
          </div>

        </div>
      </section>

      <div className={c.sectionDivider} />

      {/* SERVICES */}
      <section id="services" className={c.services}>
        <h2>Услуги</h2>

        <div className={c.servicesGrid}>
          <div className={c.serviceCard}>
            <h3>AI-решения и автоматизация</h3>
            <p>
              Чат-боты, интеллектуальные ассистенты,
              автоматизация бизнес-процессов,
              интеграция нейросетей.
            </p>
          </div>

          <div className={c.serviceCard}>
            <h3>Веб-разработка</h3>
            <p>
              Современные веб-приложения, панели управления,
              SaaS-платформы и высоконагруженные сервисы.
            </p>
          </div>

          <div className={c.serviceCard}>
            <h3>Мобильные приложения</h3>
            <p>
              Разработка приложений для iOS и Android
              с фокусом на UX, производительность и масштабируемость.
            </p>
          </div>

          <div className={c.serviceCard}>
            <h3>Поддержка и развитие продуктов</h3>
            <p>
              Техническая поддержка, развитие функционала,
              оптимизация и масштабирование существующих решений.
            </p>
          </div>
        </div>

        <div className={c.servicesCta}>
          <p>Не нашли подходящую услугу?</p>
          <a href="#contact">Опишите задачу — мы подскажем решение →</a>
        </div>
      </section>

      <div className={c.sectionDivider} />

      {/* PROCESS */}
      <section id="process" className={c.process}>
        <h2>Процесс работы</h2>

        <div className={c.processGrid}>
          <div>
            <b>01</b>
            <h4>Аналитика</h4>
            <p>Изучаем задачу, цели и ограничения проекта</p>
          </div>
          <div>
            <b>02</b>
            <h4>Проектирование</h4>
            <p>Формируем архитектуру, UX и технологический стек</p>
          </div>
          <div>
            <b>03</b>
            <h4>Разработка</h4>
            <p>Итеративная разработка, тестирование, контроль качества</p>
          </div>
          <div>
            <b>04</b>
            <h4>Запуск и сопровождение</h4>
            <p>Релиз, поддержка, развитие и масштабирование</p>
          </div>
        </div>
        <p className={c.processNote}>
          Такой подход позволяет запускать проекты быстрее
          и избегать лишних затрат.
        </p>
      </section>

      <div className={c.sectionDivider} />

      {/* ABOUT */}
      <section id="about" className={c.about}>
        <h2>Почему выбирают Retomagic</h2>
        <p>
          Мы объединяем инженерный подход, продуктовое мышление
          и практический опыт разработки AI-решений.
        </p>
        <p>
          Работаем прозрачно, соблюдаем сроки
          и берём ответственность за результат.
        </p>
      </section>

      <div className={c.sectionDivider} />

      {/* CTA */}
      <section className={c.cta}>
        <h2>Обсудим вашу задачу и предложим решение</h2>
        <p>
          Ответим в течение дня и подскажем оптимальный
          технический подход под ваш бюджет и сроки.
        </p>
        <a href="#contact" className={c.primaryBtn}>
          Начать обсуждение
        </a>
      </section>

      <div className={c.sectionDivider} />

      {/* CONTACT */}
      <section id="contact" className={c.contact}>
        <h2>Оставьте заявку</h2>

        <p className={c.contactNote}>
          Опишите задачу — мы свяжемся с вами и предложим решение
        </p>

        <div className={c.form}>
          <input placeholder="Как вас зовут?" />
          <input placeholder="Email для обратной связи" />
          <textarea placeholder="Кратко опишите задачу или идею" />
          <button type="button" className={c.primaryBtn}>
            Отправить заявку
          </button>
        </div>

        <div className={c.footerNote}>
          Работаем с бизнесом и стартапами по всему миру
        </div>
      </section>


      <footer className={c.footer}>
        © Retomagic Inc. Все права защищены.
      </footer>

    </div>
  );
}

export default DevelopmentPage
